<template>
  <DialogTabs
    :visible="visible"
    :tabs="tabs"
    @hide="$emit('hide')"
  />
</template>

<script lang="ts" setup>
import { Settings, Users } from 'lucide-vue-next'
import InformationTab from './tabs/information/InformationTab.vue'
import MembersTab from './tabs/members/MembersTab.vue'
import type { AppConfig } from '~/types/app'
import type { DialogTab } from '~/types/components/structural/organization/dialog'
import DialogTabs from '~/components/ui/dialog-tabs/DialogTabs.vue'

enum TabNames {
  Information = 'information',
  Members = 'members',
}

defineProps<{
  visible: boolean
}>()
defineEmits(['hide'])

const { t } = useI18n()
const appConfig = useAppConfig() as AppConfig
const tabs = computed<DialogTab>(() => [
  {
    label: t(
      'components.structural.organization.dialog.sidebar.labels.information',
    ),
    icon: Settings,
    name: TabNames.Information,
    component: InformationTab,
    props: {},
  },
  {
    label: t(
      'components.structural.organization.dialog.sidebar.labels.members',
    ),
    icon: Users,
    name: TabNames.Members,
    component: MembersTab,
    props: {},
  },
  ...(appConfig.dialogTabs?.organization ?? []),
])
</script>
